import React from "react";
import { ArrowRight } from "lucide-react";
import HologramHero from "../components/HologramHero";
import Icon from "../components/Icon";
import { IMAGES } from "../data/content";
import { useI18n } from "../i18n/LanguageContext";
import { scrollToSection } from "../lib/scrollNav";

const withBreaks = (lines = []) =>
  lines.map((l, i) => (
    <React.Fragment key={i}>
      {l}
      {i < lines.length - 1 && <br />}
    </React.Fragment>
  ));

export default function Home() {
  const { t } = useI18n();
  const h = t.home;

  return (
    <div data-testid="page-home">
      <HologramHero
        image={IMAGES.heroStart}
        title={withBreaks(h.hero.titleLines)}
        badges={h.hero.badges}
        paragraphs={h.hero.paragraphs}
      />

      {/* Leistungsicons */}
      <section className="py-20 bg-white" data-testid="home-services">
        <div className="max-w-[1320px] mx-auto px-5 lg:px-8">
          <div className="grid sm:grid-cols-2 lg:grid-cols-5 gap-y-12 gap-x-6">
            {t.leistungen.services.map((s) => (
              <div key={s.key} className="text-center px-2 group">
                <div className="w-16 h-16 mx-auto mb-5 rounded-2xl border-2 border-blue-100 flex items-center justify-center text-blue-brand">
                  <Icon name={s.icon} size={30} strokeWidth={1.7} />
                </div>
                <h3 className="font-head font-bold text-ink text-[15px] uppercase tracking-wide mb-2">{s.title}</h3>
                <p className="text-sm text-muted-foreground leading-relaxed">{s.long}</p>
              </div>
            ))}
          </div>
          <div className="text-center mt-14">
            <button
              onClick={() => scrollToSection("leistungen")}
              data-testid="home-leistungen-cta"
              className="inline-flex items-center gap-2 bg-blue-brand text-white font-semibold px-7 py-3.5 rounded-full hover:bg-blue-700 transition-colors cursor-pointer"
            >
              {h.servicesCta} <ArrowRight size={18} />
            </button>
          </div>
        </div>
      </section>

      {/* Why us */}
      <section className="py-20 section-soft" data-testid="home-why">
        <div className="max-w-[1320px] mx-auto px-5 lg:px-8">
          <div className="grid sm:grid-cols-2 lg:grid-cols-5 gap-x-6 gap-y-10">
            {h.why.map((w) => (
              <div key={w.title} className="border-l-2 border-blue-100 pl-5">
                <Icon name={w.icon} size={34} className="text-ink mb-4" strokeWidth={1.4} />
                <h3 className="font-head font-bold text-ink text-[15px] uppercase tracking-wide mb-2">{w.title}</h3>
                <p className="text-sm text-muted-foreground leading-relaxed">{w.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA strip */}
      <section className="py-16 bg-[#0f2747] text-white" data-testid="home-cta">
        <div className="max-w-[1320px] mx-auto px-5 lg:px-8 flex flex-col md:flex-row items-center justify-between gap-6">
          <div>
            <h2 className="font-head font-extrabold text-2xl md:text-3xl mb-2">{h.cta.title}</h2>
            <p className="text-blue-100/80">{h.cta.text}</p>
          </div>
          <button
            onClick={() => scrollToSection("kontakt")}
            data-testid="home-kontakt-cta"
            className="inline-flex items-center gap-2 bg-white text-ink font-semibold px-7 py-3.5 rounded-full hover:bg-blue-50 transition-colors whitespace-nowrap cursor-pointer"
          >
            {h.cta.button} <ArrowRight size={18} />
          </button>
        </div>
      </section>
    </div>
  );
}
